var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 18",
    style: {
      enableBackground: "new 0 0 14 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    d: "M9.9,0L14,4.1V16c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2H9.9z M12,8.7 c-0.1-0.1-0.4-0.2-0.7-0.1c-0.4,0-0.8,0.1-1.2,0.1C9.6,8.7,9.1,8.8,8.6,8.8S7.7,8.9,7.3,9C6.8,9,6.4,9.1,6.1,9.1 c-0.4,0-0.6,0.1-0.6,0.3c-0.1,0.2,0,0.4,0.3,0.6c0.1,0.1,0.3,0.3,0.5,0.5s0.3,0.4,0.5,0.5c0.2,0.2,0.2,0.3,0.1,0.5 c-0.1,0.2-0.3,0.4-0.5,0.7c-0.4,0.4-0.7,0.7-0.9,0.9l-0.1,0.1C5,13.6,4.9,13.8,4.8,14c-0.1,0.2,0.1,0.4,0.3,0.7 c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2s0.1,0.1,0.2,0.2c0.1,0.1,0.3,0.2,0.4,0.3 c0.1,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0.4-0.4,0,0,0.3-0.3c0.3-0.3,0.6-0.6,1-1 c0.2-0.2,0.3-0.3,0.5-0.3c0.1,0,0.3,0,0.4,0.2c0.1,0.1,0.3,0.3,0.5,0.5c0.2,0.2,0.4,0.4,0.5,0.5c0.2,0.2,0.4,0.3,0.6,0.2 c0.2-0.1,0.3-0.4,0.3-0.8c0-0.4,0.1-0.8,0.1-1.2c0.1-0.4,0.1-0.9,0.2-1.3c0.1-0.4,0.1-0.9,0.2-1.3s0.1-0.8,0.1-1.1S12.1,8.8,12,8.7z  M9,1v3c0,0.6,0.4,1,1,1h3L9,1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportList);
export default __webpack_public_path__ + "static/media/exportList.2b35904c5eb8ad546b3be1d42d55515b.svg";
export { ForwardRef as ReactComponent };